/**
 * 上下文类型
 */
export enum ModelContextType {
    /** 文本 */
    Text = 'text',
    /** 选中的文本 */
    SelectionText = 'selectionText',
    /** 专利 pn 号 */
    PN = 'PN',
}
